import { render, staticRenderFns } from "./IlluEvolution.vue?vue&type=template&id=ef0e1fae&"
import script from "./IlluEvolution.vue?vue&type=script&lang=js&"
export * from "./IlluEvolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports